import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a passenger car rearview
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <PassengerCarRearIcon width={12} />
 */
const PassengerCarRearIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M2.5 12.9668V10.0002C2.52926 9.47166 2.73799 8.96897 3.09167 8.57516L3.58333 8.0835C3.95837
            7.68204 4.26268 7.21995 4.48333 6.71683L5.53333 4.10016C5.63347 3.88051 5.79224 3.69272 5.99219
            3.55746C6.19214 3.4222 6.42552 3.3447 6.66667 3.3335H13.3333C13.5764 3.34571 13.8114 3.42445
            14.0127 3.56112C14.214 3.69779 14.3739 3.88714 14.475 4.1085L15.525 6.72516C15.7446 7.22885 16.049
            7.69112 16.425 8.09183L16.9167 8.5835C17.2658 8.97611 17.4715 9.47554 17.5 10.0002V12.9668L15.0917
            12.0085C14.528 11.7999 13.9341 11.6845 13.3333 11.6668H12.5V11.2502H7.5V11.6668H6.66667C6.06589
            11.6845 5.47201 11.7999 4.90833 12.0085L2.5 12.9668ZM14.7833 12.7752C14.3173 12.6086 13.828 12.5158
            13.3333 12.5002H12.5V12.9168H7.5V12.5002H6.66667C6.17197 12.5158 5.68275 12.6086 5.21667 12.7752L2.5
            13.8668V15.8335C2.5 16.0545 2.5878 16.2665 2.74408 16.4228C2.90036 16.579 3.11232 16.6668 3.33333
            16.6668H4.16667C4.38768 16.6668 4.59964 16.579 4.75592 16.4228C4.9122 16.2665 5 16.0545 5
            15.8335V15.0002H5.41667C5.41667 14.7791 5.50446 14.5672 5.66074 14.4109C5.81702 14.2546 6.02899
            14.1668 6.25 14.1668C6.39785 14.1687 6.54221 14.212 6.66667 14.2918C6.79112 14.212 6.93548 14.1687
            7.08333 14.1668C7.30435 14.1668 7.51631 14.2546 7.67259 14.4109C7.82887 14.5672 7.91667 14.7791
            7.91667 15.0002H15V15.8335C15 16.0545 15.0878 16.2665 15.2441 16.4228C15.4004 16.579 15.6123 16.6668
            15.8333 16.6668H16.6667C16.8877 16.6668 17.0996 16.579 17.2559 16.4228C17.4122 16.2665 17.5 16.0545
            17.5 15.8335V13.8668L14.7833 12.7752ZM7.08333 4.5835C6.96225 4.5912 6.84534 4.63069 6.74438
            4.69799C6.64343 4.76529 6.56201 4.85802 6.50833 4.96683L5.99167 6.2835C5.96735 6.32519 5.95529 6.3729
            5.95686 6.42114C5.95843 6.46938 5.97357 6.5162 6.00055 6.55623C6.02752 6.59625 6.06523 6.62786 6.10936
            6.64742C6.15348 6.66699 6.20223 6.67371 6.25 6.66683H13.75C13.7975 6.67273 13.8457 6.66535 13.8893
            6.64552C13.9329 6.62569 13.9701 6.59417 13.9969 6.55447C14.0236 6.51477 14.0388 6.46844 14.0409
            6.42061C14.0429 6.37278 14.0316 6.32532 14.0083 6.2835L13.4833 4.97516C13.4329 4.8639 13.3523 4.76901
            13.2507 4.70125C13.149 4.63349 13.0304 4.59558 12.9083 4.59183H7.08333V4.5835ZM6.25 14.5835C6.16759
            14.5835 6.08703 14.6079 6.01851 14.6537C5.94999 14.6995 5.89659 14.7646 5.86505 14.8407C5.83351 14.9168
            5.82526 15.0006 5.84134 15.0815C5.85742 15.1623 5.8971 15.2365 5.95537 15.2948C6.01364 15.3531 6.08789
            15.3927 6.16871 15.4088C6.24954 15.4249 6.33332 15.4166 6.40945 15.3851C6.48559 15.3536 6.55066 15.3002
            6.59645 15.2317C6.64223 15.1631 6.66667 15.0826 6.66667 15.0002C6.66667 14.8897 6.62277 14.7837 6.54463
            14.7055C6.46649 14.6274 6.36051 14.5835 6.25 14.5835ZM7.08333 14.5835C7.00092 14.5835 6.92037 14.6079
            6.85185 14.6537C6.78333 14.6995 6.72992 14.7646 6.69838 14.8407C6.66685 14.9168 6.6586 15.0006 6.67467
            15.0815C6.69075 15.1623 6.73043 15.2365 6.78871 15.2948C6.84698 15.3531 6.92122 15.3927 7.00205
            15.4088C7.08287 15.4249 7.16665 15.4166 7.24278 15.3851C7.31892 15.3536 7.384 15.3002 7.42978
            15.2317C7.47556 15.1631 7.5 15.0826 7.5 15.0002C7.5 14.8897 7.4561 14.7837 7.37796 14.7055C7.29982 14.6274
            7.19384 14.5835 7.08333 14.5835ZM5 8.3335C4.83518 8.3335 4.67407 8.38237 4.53702 8.47394C4.39998 8.56551
            4.29317 8.69565 4.2301 8.84793C4.16703 9.0002 4.15052 9.16775 4.18268 9.3294C4.21483 9.49106 4.2942 9.63954
            4.41074 9.75608C4.52729 9.87263 4.67577 9.952 4.83742 9.98415C4.99908 10.0163 5.16663 9.9998 5.3189
            9.93673C5.47117 9.87366 5.60132 9.76685 5.69289 9.6298C5.78446 9.49276 5.83333 9.33165 5.83333 9.16683C5.83333
            8.94582 5.74554 8.73385 5.58926 8.57757C5.43298 8.42129 5.22101 8.3335 5 8.3335ZM6.66667 8.3335C6.50185 8.3335
            6.34073 8.38237 6.20369 8.47394C6.06665 8.56551 5.95984 8.69565 5.89677 8.84793C5.83369 9.0002 5.81719 9.16775
            5.84935 9.3294C5.8815 9.49106 5.96087 9.63954 6.07741 9.75608C6.19395 9.87263 6.34244 9.952 6.50409
            9.98415C6.66574 10.0163 6.8333 9.9998 6.98557 9.93673C7.13784 9.87366 7.26799 9.76685 7.35956 9.6298C7.45113
            9.49276 7.5 9.33165 7.5 9.16683C7.5 8.94582 7.4122 8.73385 7.25592 8.57757C7.09964 8.42129 6.88768 8.3335
            6.66667 8.3335ZM13.3333 8.3335C13.1685 8.3335 13.0074 8.38237 12.8704 8.47394C12.7333 8.56551 12.6265 8.69565
            12.5634 8.84793C12.5004 9.0002 12.4839 9.16775 12.516 9.3294C12.5482 9.49106 12.6275 9.63954 12.7441
            9.75608C12.8606 9.87263 13.0091 9.952 13.1708 9.98415C13.3324 10.0163 13.5 9.9998 13.6522 9.93673C13.8045
            9.87366 13.9347 9.76685 14.0262 9.6298C14.1178 9.49276 14.1667 9.33165 14.1667 9.16683C14.1667 8.94582 14.0789
            8.73385 13.9226 8.57757C13.7663 8.42129 13.5543 8.3335 13.3333 8.3335ZM15 8.3335C14.8352 8.3335 14.6741 8.38237
            14.537 8.47394C14.4 8.56551 14.2932 8.69565 14.2301 8.84793C14.167 9.0002 14.1505 9.16775 14.1827 9.3294C14.2148
            9.49106 14.2942 9.63954 14.4107 9.75608C14.5273 9.87263 14.6758 9.952 14.8374 9.98415C14.9991 10.0163 15.1666
            9.9998 15.3189 9.93673C15.4712 9.87366 15.6013 9.76685 15.6929 9.6298C15.7845 9.49276 15.8333 9.33165 15.8333
            9.16683C15.8333 8.94582 15.7455 8.73385 15.5893 8.57757C15.433 8.42129 15.221 8.3335 15 8.3335Z`}
        />
    </SvgIcon>
)

PassengerCarRearIcon.defaultProps = defaultProps

export { PassengerCarRearIcon }
